import { Component, Input, OnInit } from '@angular/core';
import { Form, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { UserService } from '../../../services/user.service';
import { NotificationService } from '../../../services/notification.service';
import { LocationModalComponent } from '../location-modal/location-modal.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-address-modal',
  templateUrl: './add-address-modal.component.html',
  styleUrl: './add-address-modal.component.scss',
})
export class AddAddressModalComponent implements OnInit {
  @Input() defaultAddress?: any;

  constructor(
    private http: ApiService,
    private user: UserService,
    private notify: NotificationService,
    private modal: NgbModal,
    public activeModal: NgbActiveModal
  ) {}
  locationSub: any;
  isLoading = false;
  registerForm = new FormGroup({
    title: new FormControl(''),
    blockNo: new FormControl(''),
    landmark: new FormControl(''),
    address: new FormControl('', Validators.required),
    state: new FormControl('', Validators.required),
    zipcode: new FormControl('', [
      Validators.pattern('[0-9]+'),
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(6),
    ]),
    city: new FormControl('', Validators.required),
    area: new FormControl(''),
    latVal: new FormControl('', Validators.required),
    lngVal: new FormControl('', Validators.required),
    zone: new FormControl(''),
    primaryAddress: new FormControl(false, Validators.required),
  });

  ngOnInit() {}

  f = (control) => this.registerForm.get(control) as FormControl;

  onSubmit() {
    const { status, value } = this.registerForm;
    console.log(this.registerForm);
    if (status == 'INVALID') {
      this.registerForm.markAllAsTouched();
      return;
    }
    console.log(value);
    const data = {
      url: 'retailers/addaddress',
      payload: value,
      message: 'Address added successfully',
    };
    this.isLoading = true;
    this.http.post(data.url, data.payload).subscribe((res) => {
      console.log(res);
      this.isLoading = false;

      if (res.code == 1) {
        this.notify.showSuccess(data.message, '');
        const address = {
          id: res.data.addressId,
          address: res.data.address,
          name: res.data.title,
        };
        this.activeModal.close(address);
      } else {
        this.notify.showError(res.message, '');
      }
    });
  }

  async selectLocation() {
    const ref = this.modal.open(LocationModalComponent, {
      size: 'lg',
      centered: true,
    });
    ref.componentInstance.defaultAddress = this.defaultAddress;
    // ref.componentInstance.defaultAddress =
    //   'W4F2+X2C Karim.molla, Karummariamman Nagar, Vishnu Nagar, Tambaram, Chennai, Tamil Nadu 600045, India';

    try {
      const res = await ref.result;

      const { coords, place } = res;
      const arr = place.address_components;

      this.registerForm.patchValue({
        latVal: coords.lat.toFixed(6),
        lngVal: coords.lng.toFixed(6),
        address: place.formatted_address,
        area: this.user.decodeAddress(arr, 'administrative_area_level_2'),
        city: this.user.decodeAddress(arr, 'locality'),
        zone: this.user.decodeAddress(arr, 'administrative_area_level_2'),
        zipcode: this.user.decodeAddress(arr, 'postal_code'),
        state: this.user.decodeAddress(arr, 'administrative_area_level_1'),
      });
    } catch {
      // Modal dismissed
    }
  }

  cancel() {
    this.activeModal.dismiss();
  }
}
